import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { UserTitleType } from '../enums/user-title-type.enum';
import { Component, Input, OnDestroy, HostListener, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Categories } from '../../products/interfaces/categories.interface';
import { Product } from '../../products/interfaces/product.interface';
import { CommonService } from '../services/common.service';
import { AppMessageService } from '../../app-message.service';
import { ConfigurationService } from '../services/configuration.service';
import { TranslateModule, TranslateLoader, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { StoreConfig } from '../interfaces/store-config.interface';
import { environment } from '../../../environments/environment';
import { ProductService } from '../../common/services/product.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-product-search',
  templateUrl:
    '../templates/template1/views/product-search.component.html',
  styleUrls: [
    '../templates/template1/themes/default/less/app-product-search.component.less'
  ]
})
export class ProductSearchComponent implements OnInit {
  languageCode: any;
  activeIndex = -1;
  storeId: number;
  hideValue: boolean;
  originalSearchedString: any = [];
  previouslySearchedString: any = [];
  productSearchHistory: any;
  languageCultures: any = [];
  store: StoreConfig;
  @Input() isShow: boolean;
  searchValue = '';
  isoCountryCode: string;
  // tslint:disable-next-line:no-input-rename
  @Input('showSearch') isSearchHeaderShown;
  @Input() isMobile;
  @Output() productSearchShown: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasError = false;
  isSubmitted = false;

  @ViewChild('searchBox',{static:false}) searchBox: ElementRef;


  constructor(
    private _commonService: CommonService,
    private _appMessageService: AppMessageService,
    private _configurationService: ConfigurationService,
    private _cacheService: CacheService
  ) { }

  ngOnInit() {
    this.getStoreData();
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    this.isoCountryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this._appMessageService.isSearchBoxVisibile().subscribe((canShow: boolean) => {
      this.isSearchHeaderShown = canShow;
      this.isSubmitted = false;
      if (this.searchBox) {
        this.searchValue = '';
        this.searchBox.nativeElement.focus();
      }
    });
    const searchedTexts = [];
    this.productSearchHistory = {
      lang: this.languageCode,
      searchTexts: searchedTexts
    };
    if (this._cacheService.getCookieValue(CacheKey.RecentSearch)) {
      const previousHistory = JSON.parse(this._cacheService.getCookieValue(CacheKey.RecentSearch));
      this.languageCultures = previousHistory;
      if (previousHistory.filter(x => x.lang === this.languageCode).length > 0) {
        this.productSearchHistory = previousHistory.filter(x => x.lang === this.languageCode);
      } else {
        this.languageCultures.push(this.productSearchHistory);
        this._cacheService.setCookieValue(CacheKey.RecentSearch, JSON.stringify(this.languageCultures));
      }
      this.previouslySearchedString = this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts
        : this.productSearchHistory[0].searchTexts ? this.productSearchHistory[0].searchTexts : [];
      this.originalSearchedString = this.previouslySearchedString.slice().reverse();
    } else {
      this.languageCultures.push(this.productSearchHistory);
      this._cacheService.setCookieValue(CacheKey.RecentSearch, JSON.stringify(this.languageCultures));
    }
  }

  /**
      * checkAndAdd used to check if a culture code is already present or not
      * @returns boolean
      */
  checkAndAdd(): boolean {
    this.languageCultures = this.languageCultures.map(ele => {
      if (ele.lang === this.languageCode) {
        ele.searchTexts = this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts :
          this.productSearchHistory[0].searchTexts;
      }
      return ele;
    });
    return true;
  }
  
  /** On return/enter key pressed in mobile
   * @description
   * @author njagadeesan
   * @date 2019-11-25
   * @param {KeyboardEvent} event
   * @memberof ProductSearchComponent
   */
  onKeyUp(event: KeyboardEvent): void {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 13) {
      this.searchProducts();
    }
  }

  /**
   * headerSearch based user entered value selected category
   * @returns void
   */
  searchProducts(): void {
    this.isSubmitted = true;
    if (!this.searchValue) {
      this.hasError = true;
      return;
    }
    const headerSearch = {
      category: { id: 0, categoryName: 'All Categories' },
      searchValue: this.searchValue
    };

    if (this.searchValue !== '') {
      if (this.productSearchHistory.searchTexts) {
        if ((this.productSearchHistory.searchTexts) && this.productSearchHistory.searchTexts.indexOf(
          this.searchValue.toLowerCase()) === -1) {
          if (this.productSearchHistory && this.productSearchHistory.searchTexts.length >= 5) {
            this.productSearchHistory.searchTexts.shift();
            this.productSearchHistory.searchTexts.push(this.searchValue.toLowerCase());
          } else {
            this.productSearchHistory.searchTexts.push(this.searchValue.toLowerCase());
          }
        } else {
          this.productSearchHistory.searchTexts.splice(this.productSearchHistory.searchTexts.indexOf(this.searchValue.toLowerCase()), 1);
          this.productSearchHistory.searchTexts.push(this.searchValue.toLowerCase());
        }
      } else {
        if ((this.productSearchHistory[0].searchTexts) && this.productSearchHistory[0].searchTexts.indexOf(
          this.searchValue.toLowerCase()) === -1) {
          if (this.productSearchHistory && this.productSearchHistory[0].searchTexts.length >= 5) {
            this.productSearchHistory[0].searchTexts.shift();
            this.productSearchHistory[0].searchTexts.push(this.searchValue.toLowerCase());
          } else {
            this.productSearchHistory[0].searchTexts.push(this.searchValue.toLowerCase());
          }
        } else {
          this.productSearchHistory[0].searchTexts.splice(this.productSearchHistory[0].searchTexts.indexOf(
            this.searchValue.toLowerCase()), 1);
          this.productSearchHistory[0].searchTexts.push(this.searchValue.toLowerCase());
        }
      }
    }

    this.previouslySearchedString = this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts :
      this.productSearchHistory[0].searchTexts;
    this.originalSearchedString = this.previouslySearchedString.slice().reverse();
    {
      if (this.checkAndAdd()) {
      } else {
        this.languageCultures.push(this.productSearchHistory);
      }
      this._cacheService.setCookieValue(CacheKey.RecentSearch, JSON.stringify(this.languageCultures));
    }
    this._cacheService.setCookieValue(CacheKey.HeaderSearch, JSON.stringify(headerSearch));
    let redirectURL = environment.shopURL + '/' + this.isoCountryCode.toLowerCase() + '/'
      + this.languageCode.toLowerCase() + '/products?search=' + this.searchValue;
    redirectURL = this._commonService.appendFBOID(redirectURL);
    window.location.href = redirectURL;
  }

  /**
  * close search header input
  * @returns void
  */
  closeSearchInput(): void {
    if (this.isSearchHeaderShown) {
      this.isSearchHeaderShown = !this.isSearchHeaderShown;
      this._appMessageService.setSearchBoxVisibility(this.isSearchHeaderShown);
    }
  }

  /**
     * passIndex method used to delete search values
     * @param  {number} index
     * @param  {Event} event
     * @returns void
     */
  passIndex(index: number): void {
    const length = this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts.length :
      this.productSearchHistory[0].searchTexts.length;
    index = (length - 1) - index;
    this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts.splice(index, 1) :
      this.productSearchHistory[0].searchTexts.splice(index, 1);
    this.activeIndex = -1;
    this.hideValue = true;
    this.previouslySearchedString = this.productSearchHistory.searchTexts ? this.productSearchHistory.searchTexts :
      this.productSearchHistory[0].searchTexts;
    this.originalSearchedString = this.previouslySearchedString.slice().reverse();
    this.searchValue = '';
    this.checkAndAdd();
    this._cacheService.setCookieValue(CacheKey.RecentSearch, JSON.stringify(this.languageCultures));
  }

  /**
   * fetchProducts method used to perform search based upon keyup enter on the recent search lists
   * @returns void
   */
  fetchProducts(): void {
    if (this.searchValue === '') {
      if (this.activeIndex > -1) {
        this.searchValue = this.originalSearchedString[this.activeIndex];
        this.searchProducts();
      }
    } else {
      this.searchProducts();
    }
  }

  /**
  * nextActiveMatch method used to update Index value based on Key down
  * @param  {Event} e
  * @returns void
  */
  nextActiveMatch(e: Event): void {
    this.activeIndex = this.activeIndex < this.originalSearchedString.length - 1 ? ++this.activeIndex : -1;
  }

  /**
   * prevActiveMatch method used to update Index value based on Key Up
   * @param  {Event} e
   * @returns void
   */
  public prevActiveMatch(e: Event): void {
    this.activeIndex = this.activeIndex > 0 ? --this.activeIndex : --this.activeIndex === -2 ? this.originalSearchedString.length - 1 : -1;
  }

  getStoreData() {
    const result: StoreConfig = this._configurationService.getStoreData();
    if (result != null) {
      this.store = result;
      this.storeId = this.store.id;
    }
  }

  /**
   * hides search box , pass boolean value to header
   * @return void
   */
  hideSearchBox(): void {
    this._appMessageService.setSearchBoxVisibility(false);
  }

  focusOut(event: any) {
    if (event.which === 13) {
      document.getElementById('search').blur();
    }
    if (this.searchValue) {
      this.hasError = false;
    }
    if (!this.searchValue && this.isSubmitted) {
      this.hasError = true;
    }
    if (38 === event.keyCode) {
      return this.prevActiveMatch(event);
    }
    if (40 === event.keyCode) {
      return this.nextActiveMatch(event);
    }
    if (27 === event.keyCode) {
      this.isSearchHeaderShown = false;
    }
    return;
  }

  /**
   * keyup handler for search input
   * @return void
   */
  onSearchKeyHandled(evt: any): void {
    if (evt.keyCode === 27) {
      this.hideSearchBox();
    }
  }
}
